import React from 'react';
import { Checkbox, Tooltip } from '@mui/material';
import { contrAgentTypeList } from '~/constants/directoryList.ts';
import { ComplexServiceCheckboxValue } from '../types.ts';
import { getComplexServiceCheckboxSx } from '../styles.ts';

export interface ComplexServiceCheckboxProps {
  value?: ComplexServiceCheckboxValue | null;
  recordKey: string | number;
  fieldName: string;
  onChange?: (recordKey: string | number, fieldName: string, checked: boolean) => void;
}

export const ComplexServiceCheckbox = ({
  value,
  recordKey,
  fieldName,
  onChange,
}: ComplexServiceCheckboxProps) => {
  if (!value) return <Checkbox disabled />;

  const { clientType, selected, counterpartyName, counterpartyCode } = value;

  const hasValidCounterpartyInfo = counterpartyName !== undefined && counterpartyCode !== undefined;

  const tooltipTitle =
    clientType === 'INDIVIDUAL'
      ? contrAgentTypeList.SOLE_TRADER
      : clientType === 'REPRESENTATIVE'
        ? hasValidCounterpartyInfo
          ? `${contrAgentTypeList.LEGAL_RESIDENT}: ${counterpartyName}, ${counterpartyCode}`
          : contrAgentTypeList.CONTR_AGENT_TYPE
        : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(recordKey, fieldName, e.target.checked);
    }
  };

  return (
    <Tooltip title={tooltipTitle}>
      <Checkbox
        checked={selected}
        onChange={handleChange}
        sx={getComplexServiceCheckboxSx(clientType)}
      />
    </Tooltip>
  );
};
